import { useEffect, useState } from "react";

const SCREEN_SIZE_THRESHOLD = 600;

export const useIsMobile = (breakpoint = SCREEN_SIZE_THRESHOLD) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < breakpoint);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < breakpoint);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [breakpoint]);

  return isMobile;
};
